/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForAlertsAzure extends models.GovernanceConfigurationBaseForAlerts {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForAlertsAzure");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForAlertsAzure.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForAlertsAzure>): GovernanceConfigurationForAlertsAzure {
        let obj = Object.assign(new GovernanceConfigurationForAlertsAzure(), model);
        GovernanceConfigurationForAlertsAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForAlertsAzure>): GovernanceConfigurationForAlertsAzure {
        if (!model) return null;
        return GovernanceConfigurationForAlertsAzure.newInstance(<GovernanceConfigurationForAlertsAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForAlertsAzure) {
        if (!obj) return;

        models.GovernanceConfigurationForAlertsAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForAlertsAzure): boolean {
        if (models.GovernanceConfigurationBaseForAlerts.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForAlertsAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource Group Name
     */
    resource_group: string;

    /**
     * Action Group
     */
    action_group: string;

    /**
     * Specifies the alert configuration level.
     */
    is_subscription_scope: boolean;

}
